import Cookies from 'js-cookie'

export const state = () => {
  return {
    token: '',
    userInfo: {}
  }
}

export const mutations = {
  SET_USER(state, user) {
    state.userInfo = { ...user }
  },
  SET_TOKEN(state, token) {
    state.token = token
    !!token ? Cookies.set('token', token) : Cookies.remove('token')
  }
}
